export const APP_NAME = import.meta.env.VITE_APP_NAME || 'menu.pictures';
export const CANONICAL_URL = import.meta.env.VITE_CANONICAL_URL || 'https://menu.pictures';
